import { useReducer } from 'react'
import type { ForgotPasswordFlowAction, ForgotPasswordFlowState } from './ForgotPasswordFlow.types'

const initialState: ForgotPasswordFlowState = {
  email: '',
  submitting: false,
  success: false,
  error: '',
  emailTouched: false,
}

const forgotPasswordFlowReducer = (
  state: ForgotPasswordFlowState,
  action: ForgotPasswordFlowAction,
): ForgotPasswordFlowState => {
  switch (action.type) {
    case 'SET_EMAIL': {
      return {
        ...state,
        email: action.value,
      }
    }
    case 'SET_SUBMITTING': {
      return {
        ...state,
        submitting: action.value,
      }
    }
    case 'SET_SUCCESS': {
      return {
        ...state,
        success: action.value,
      }
    }
    case 'SET_ERROR': {
      return {
        ...state,
        error: action.value,
      }
    }
    case 'SET_EMAIL_TOUCHED': {
      return {
        ...state,
        emailTouched: action.value,
      }
    }
    default:
      return state
  }
}

export const useForgotPasswordFlowReducer = () => useReducer(forgotPasswordFlowReducer, initialState)
